module.exports = __webpack_public_path__ + "../resources/img/img_ef_layer2_no-inverter.edea4a49.svg";